// Lazy Loading Module for Performance Optimization
class LazyLoader {
  constructor() {
    this.imageObserver = null;
    this.init();
  }

  init() {
    // Check if Intersection Observer is supported
    if ('IntersectionObserver' in window) {
      this.setupIntersectionObserver();
    } else {
      // Fallback for older browsers
      this.loadAllImages();
    }
  }

  setupIntersectionObserver() {
    const imageOptions = {
      root: null,
      rootMargin: '50px 0px',
      threshold: 0.01,
    };

    this.imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          this.loadImage(img);
          observer.unobserve(img);
        }
      });
    }, imageOptions);

    // Observe all lazy images
    this.observeImages();
  }

  observeImages() {
    const lazyImages = document.querySelectorAll('img[data-src]');
    lazyImages.forEach(img => {
      this.imageObserver.observe(img);
    });
  }

  loadImage(img) {
    const src = img.getAttribute('data-src');
    if (src) {
      // Create a new image to preload
      const imageLoader = new Image();

      imageLoader.onload = () => {
        img.src = src;
        img.classList.add('loaded');
        img.removeAttribute('data-src');
      };

      imageLoader.onerror = () => {
        // Fallback to placeholder
        img.src =
          'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZjBmMGYwIi8+PC9zdmc+';
        img.classList.add('error');
      };

      imageLoader.src = src;
    }
  }

  loadAllImages() {
    // Fallback for browsers without Intersection Observer
    const lazyImages = document.querySelectorAll('img[data-src]');
    lazyImages.forEach(img => {
      this.loadImage(img);
    });
  }
}

// Add lazy loading styles
export function addLazyLoadingStyles() {
  const style = document.createElement('style');
  style.textContent = `
    img[data-src] {
      opacity: 0;
      transition: opacity 0.3s ease;
    }
    img[data-src].loaded {
      opacity: 1;
    }
  `;
  document.head.appendChild(style);
}

// Initialize lazy loading
export function initializeLazyLoading() {
  new LazyLoader();
}

// Lazy loading is initialized by app.js

export default LazyLoader;
